module.exports = __webpack_public_path__ + "images/fietsnet_small628b7ebad42b14a9f986154154523022.png";